// extracted by mini-css-extract-plugin
export default {"wrapper":"FoodSocialBlock_wrapper__duosf","block":"FoodSocialBlock_block__l3JKD","skeletonWrapper":"FoodSocialBlock_skeletonWrapper__g8Ef4"};